var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.resources),function(resource){return _c('ShowScheduleVerticalTile',{key:("" + (resource.id) + (resource.scheduled_start_time)),attrs:{"playlist-item":resource,"artwork":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }